import React from 'react';
import { Step } from 'components/SteppedModal';
import SocialShareModalFooterAuthButton from 'containers/SocialShareModal/SocialShareModalFooter/SocialShareModalFooterAuthButton';
import { YouTubeSocialShareStep } from '../../types';
import YouTubeDisallowedAccountStep from './YouTubeDisallowedAccountStep';

export default function useYouTubeDisallowedAccountStep(): Step<
  YouTubeSocialShareStep
> {
  return {
    id: 'disallowed-account',
    component: <YouTubeDisallowedAccountStep />,
    fluidFooterButtons: true,
    renderFooterButtons: () => [
      <SocialShareModalFooterAuthButton key="auth" size="large">
        select another account
      </SocialShareModalFooterAuthButton>,
    ],
  };
}
